<template>
  <OrderCard :title="t('order.cardTitles.personalData')">
    <FormField v-slot="{ componentField }" name="person.first_name">
      <FormItem>
        <FormLabel for="first_name">
          {{ t("order.formLabels.firstName") }}
        </FormLabel>
        <FormControl>
          <Input id="first_name" v-bind="componentField" autocomplete="given-name" />
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>
    <FormField v-slot="{ componentField }" name="person.last_name">
      <FormItem>
        <FormLabel for="last_name">
          {{ t("order.formLabels.lastName") }}
        </FormLabel>
        <FormControl>
          <Input id="last_name" v-bind="componentField" autocomplete="family-name" />
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>
    <FormField
      v-slot="{ componentField, value, setValue }"
      name="person.phone_number"
    >
      <FormItem>
        <FormLabel for="phone_number">
          {{ t("order.formLabels.phoneNumber") }}
        </FormLabel>
        <FormControl>
          <Input
            id="phone_number"
            type="tel"
            v-bind="componentField"
            :model-value="value"
            autocomplete="tel"
            maxlength="12"
            @input="onPhoneInput($event, setValue)"
            @change="onPhoneInput($event, setValue)"
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>
    <FormField v-slot="{ componentField }" name="person.email">
      <FormItem>
        <FormLabel for="email"> {{ t("order.formLabels.email") }}</FormLabel>
        <FormControl>
          <Input id="email" v-bind="componentField" autocomplete="email" />
        </FormControl>
        <FormMessage />
      </FormItem>
    </FormField>
  </OrderCard>
</template>
<script setup lang="ts">
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../form";
import {Input} from "../../input";
import { useI18n } from "vue-i18n";
import { OrderCard } from "../../card";

const { t } = useI18n();

function onPhoneInput(event: Event, setValue: (val: string) => void) {
  const target = event.target as HTMLInputElement;
  let val = target.value.trim();

  if (val.length > 0 && !val.startsWith("+")) {
    // Normalise international dialling prefix (e.g. 0048… → +48…)
    if (val.startsWith("00")) {
      val = "+" + val.slice(2).replace(/\D/g, "");
    } else {
      val = "+48" + val.replace(/^0/, "").replace(/\D/g, "");
    }
  } else if (val.startsWith("+")) {
    val = "+" + val.slice(1).replace(/\D/g, "");
  }

  setValue(val);
}
</script>
